module.exports = __webpack_public_path__ + "img/MAG_Interactive.3db3727b.png";